/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Filter_All_ClientsInputs */

const en_dashboard_filter_all_clients = /** @type {(inputs: Dashboard_Filter_All_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All clients`)
};

const pt_br2_dashboard_filter_all_clients = /** @type {(inputs: Dashboard_Filter_All_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os clientes`)
};

/**
* | output |
* | --- |
* | "All clients" |
*
* @param {Dashboard_Filter_All_ClientsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_filter_all_clients = /** @type {((inputs?: Dashboard_Filter_All_ClientsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Filter_All_ClientsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_filter_all_clients(inputs)
	return pt_br2_dashboard_filter_all_clients(inputs)
});